import type { CssGeneratorContext } from '../css-generator.model';

/**
 * A native `<table class="admin-config-table">` on an admin create/edit page: every `th` takes the header typography,
 * a `.cell-text` cell the plain text size and a `.cell-error` line the error size. Layout, spacing and colour roles stay
 * on the template.
 */
export const styles = ({ dt }: CssGeneratorContext) => `
.admin-config-table th {
  font-size: ${dt('adminConfigTable.header.fontSize')};
  line-height: ${dt('adminConfigTable.header.lineHeight')};
  font-weight: ${dt('adminConfigTable.header.fontWeight')};
}

.admin-config-table .cell-text {
  font-size: ${dt('adminConfigTable.cellText.fontSize')};
  line-height: ${dt('adminConfigTable.cellText.lineHeight')};
}

.admin-config-table .cell-error {
  font-size: ${dt('adminConfigTable.cellError.fontSize')};
  line-height: ${dt('adminConfigTable.cellError.lineHeight')};
}
`;
